// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  duelId: __t.u64().primaryKey().name("duel_id"),
  worldId: __t.u64().name("world_id"),
  a: __t.identity(),
  b: __t.identity(),
  state: __t.string(),
  ruleset: __t.string(),
  siteId: __t.u64().name("site_id"),
  ringX: __t.f32().name("ring_x"),
  ringZ: __t.f32().name("ring_z"),
  ringR: __t.f32().name("ring_r"),
  readyA: __t.bool().name("ready_a"),
  readyB: __t.bool().name("ready_b"),
  outSinceA: __t.timestamp().name("out_since_a"),
  outSinceB: __t.timestamp().name("out_since_b"),
  gen: __t.u32(),
  invitedAt: __t.timestamp().name("invited_at"),
  startsAt: __t.timestamp().name("starts_at"),
  endsAt: __t.timestamp().name("ends_at"),
  winner: __t.identity(),
  result: __t.string(),
  finishedAt: __t.timestamp().name("finished_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
